import { JourneyData, JourneyTarget } from '@cash-web/shared-journey-util-main'

export type JourneyState = {
  history: JourneyData[]
}

export type JourneyAction =
  | {
      type: 'JOURNEY_START'
      journey: JourneyData
    }
  | {
      type: 'JOURNEY_CANCEL'
      journeyId?: string
    }
  | {
      type: 'JOURNEY_COMPLETE'
      journeyId?: string
    }
  | {
      type: 'JOURNEY_CANCEL_ALL'
      excludeTargets?: JourneyTarget[]
      rootId?: string
    }
  | {
      type: 'JOURNEY_LOCATION_CHANGE'
      location: string
    }

export const journeyPaneReducer = (state: JourneyState, action: JourneyAction): JourneyState => {
  switch (action.type) {
    case 'JOURNEY_START': {
      const currentJourney = action.journey

      const history = currentJourney.opts?.replace ? state.history.slice(0, -1) : state.history

      if (process.env['NODE_ENV'] === 'development') {
        localStorage.setItem(
          'journeys',
          JSON.stringify([
            { ...currentJourney, timeStamp: new Date() },
            ...JSON.parse(localStorage.getItem('journeys') ?? '[]').slice(0, 99),
          ])
        )
      }

      return {
        history: [...history, currentJourney],
      }
    }
    case 'JOURNEY_CANCEL':
    case 'JOURNEY_COMPLETE': {
      const history = action.journeyId
        ? state.history.filter(h => h.journeyId !== action.journeyId)
        : state.history.slice(0, -1)

      return {
        history,
      }
    }
    case 'JOURNEY_CANCEL_ALL': {
      const history = state.history.filter(h => {
        const target = h.opts?.scope?.['target']
        const isExcludedTarget = target && action.excludeTargets?.includes(target)
        const isNotRelated = action.rootId && h.rootId !== action.rootId
        return isExcludedTarget || isNotRelated
      })

      return {
        history,
      }
    }
    case 'JOURNEY_LOCATION_CHANGE': {
      const history = state.history.filter(h => h.location === action.location || h.location === 'global')
      return {
        history,
      }
    }
    default: {
      return state
    }
  }
}
